import { Action } from '@reduxjs/toolkit';

import { GENERATE_SCRIPT_FAILED, GenerateScriptFailedAction } from 'js/actionCreators/aiFeaturesActions';
import { EDITOR_CLOSED, EditorClosedAction } from 'js/actionCreators/editorActions';
import { UPDATE_SCRIBE, UpdateScribeAction } from 'js/actionCreators/scribeActions';
import { SHOW_LEFT_HAND_PANEL, ShowLeftHandPanelAction } from 'js/actionCreators/uiActions';

export const isEditorCloseAction = (action: Action): action is EditorClosedAction => {
  return action.type === EDITOR_CLOSED;
};

export const isUpdateScribeAction = (action: Action): action is UpdateScribeAction => {
  return action.type === UPDATE_SCRIBE;
};

export const isGenerateScriptFailedAction = (action: Action): action is GenerateScriptFailedAction => {
  return action.type === GENERATE_SCRIPT_FAILED;
};

export const isShowLeftHandPanelAction = (action: Action): action is ShowLeftHandPanelAction => {
  return action.type === SHOW_LEFT_HAND_PANEL;
};
